import { render } from "./ResortView.vue?vue&type=template&id=23d064ef"
import script from "./ResortView.vue?vue&type=script&lang=js"
export * from "./ResortView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__